import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { selectLayoutListItems } from "../../../../redux/layouts/selector";
import { layouts } from "../../../../redux/layouts/action";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";

const Layouts = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
	const { header, footer, currency } = result
    const itemsData = useSelector(selectLayoutListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Message.LayoutName', headerName: 'LayoutName' ,searchField: 'LayoutName', filter: true,
            filterType: 'text'},
          { field: 'Message.PlatformWebSiteName', headerName: 'PlatformWebSiteName' },
         
          { field: 'Message.PageName', headerName: 'PageName'},
      
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(layouts.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/list`,entity:'layouts',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
      }
    
      const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
      }

      const handleReloadData = () => {
        dispatch(layouts.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/list`,entity:'layouts',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const handleAdd=()=>{
        navigate(`platform-website-layout/${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`platform-website-layout/${data?.Message?.Id}`)
      }
      
      const handleDelete=(data: any)=>{
        dispatch(layouts.delete({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/delete`,
          entity: 'layouts',
          jsonData: {
            Records: [
              {
              "context": {},
              "message": {
                    Id: data?.Message?.Id
                }
              }
            ]
          }
      })).then(() => {
          dispatch(layouts.list({
              url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/list`,
              entity: 'layouts',
              jsonData: { "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const additionButtons: any = [
        {
          svg:
           <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
             <title>Add Layout</title>
             <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
           </svg>,
         callback: () => handleAdd(),
       },
   
           {
             svg:
             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
             <title>Reload</title>
             <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
           </svg>,
           // name: 'Reload',
           callback: () => handleReloadData(),
           },
      ];
      const fetchRoutes=()=>{
        dispatch(layouts.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/list`,entity:'layouts',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchRoutes()
	}, [pageData,pageSize])

	return (
    <>
    {itemsData?.isLoading ?  <PageLoader />
  : 
		<Table   enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Layouts"/>
     
  }
  </>
     
	);
};

export default Layouts;


